import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Card from "../ui/Card";
import { EmptyState } from "../ui/Table";
import { Package } from "lucide-react";
import { formatUSD } from "../../lib/formatters";

export default function RevenuePerOfferChart({ offerStats }) {
  const data = offerStats.map((o) => ({ name: o.name, revenue: o.totalRevenue }));
  const empty = data.every((d) => d.revenue === 0);
  return (
    <Card title="Revenue per offer (lifetime)">
      {empty ? (
        <EmptyState icon={Package} title="No offer revenue yet" message="Once payments come in, revenue will be attributed per offer here." />
      ) : (
        <div style={{ width: "100%", height: 260 }}>
          <ResponsiveContainer>
            <BarChart data={data} layout="vertical" margin={{ left: 30 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" horizontal={false} />
              <XAxis type="number" tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} tickFormatter={(v) => formatUSD(v, { compact: true })} />
              <YAxis dataKey="name" type="category" tick={{ fontSize: 11, fill: "#6d7a97" }} axisLine={false} tickLine={false} width={180} />
              <Tooltip formatter={(v) => formatUSD(v)} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
              <Bar dataKey="revenue" fill="#3480f1" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </Card>
  );
}
